import { render, staticRenderFns } from "./WriteOffModal.template.vue?vue&type=template&id=68ba181a&scoped=true&"
var script = {}
import style0 from "./WriteOffModal.template.vue?vue&type=style&index=0&id=68ba181a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba181a",
  null
  
)

export default component.exports